export default __webpack_public_path__ + "static/media/ceramol-crema-viso.01235bcf.png";